import { Skeleton } from '@/components/ui';

export default function ProfileChipSkeleton(): React.ReactNode {
  return (
    <Skeleton
      aria-label='Loading profile actions'
      className='size-9 rounded-lg bg-zinc-700'
    />
  );
}
